import { L } from '@lang';
import { Trans } from 'react-i18next';
import { imageGetters } from '../../helpers/imageGetters';
import { Header } from '../../widgets/Header';
import { Instruction, InstallPage } from '../../shared/ui';
import { ReactComponent as ShareIcon } from './assets/share.svg';
import styles from './PwaInstallChrome.module.css';

export function PwaInstallChrome() {
  return (
    <InstallPage>
      <Header />
      <Instruction>
        <Instruction.Item
          title={
            <Trans
              i18n={L.i18n}
              i18nKey="pwa_install_chrome_share_icon_title"
              components={{ icon: <ShareIcon className={styles.share} /> }}
            />
          }
          srcSet={imageGetters.iosSteps('safari-share-icon')}
          aspectRatio={540 / 148}
        />
        <Instruction.Item
          title={<Trans i18n={L.i18n} i18nKey="pwa_install_chrome_show_more_button_title" components={{ b: <b /> }} />}
          srcSet={imageGetters.iosSteps('show-more-button')}
          aspectRatio={540 / 148}
        />
        <Instruction.Item
          title={
            <Trans i18n={L.i18n} i18nKey="pwa_install_chrome_add_to_home_screen_title" components={{ b: <b /> }} />
          }
          srcSet={imageGetters.iosSteps('add-to-home-screen')}
          aspectRatio={540 / 148}
        />
        <Instruction.Item
          title={L.t('pwa_install_chrome_add_to_home_confirm_title')}
          srcSet={imageGetters.iosSteps('add-to-home-confirm')}
          aspectRatio={540 / 148}
        />
        <Instruction.Item
          title={L.t('pwa_install_chrome_notifications_permission_title')}
          srcSet={imageGetters.iosSteps('notifications-permission')}
          aspectRatio={540 / 148}
        />
        <Instruction.Item
          title={L.t('pwa_install_chrome_push_notification_title')}
          srcSet={imageGetters.iosSteps('push-notification')}
          aspectRatio={540 / 148}
        />
      </Instruction>
    </InstallPage>
  );
}
